import IndustrialFacility from "./IndustrialFacility";
import AccessoriesAndFixedFittings from "../accessoriesAndFixedFittings/AccessoriesAndFixedFittings";
function ParentIndustrialFacility(props={}) {
  return (
    <>
      <IndustrialFacility disabled={props.preview}/>
      <AccessoriesAndFixedFittings parentComponent='parentIndustrialFacility' component='mainData' disabled={props.preview} />
    </>
  );
};

export default ParentIndustrialFacility;